
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/SentProjectsList/SentProjectsList.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./SentProjectsList.html');
        
        var script = require('./SentProjectsList.ts').default;
        module.exports = require('./SentProjectsList.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    